import styled from 'styled-components'

export const AnsweredWrapper = styled.div`
font-size: 17px !important;
color: ${props => props.theme.firstColor};
font-style: italic;
font-weight: bold;
`

export const AnsweredContainer = styled.div`
min-width: 400px;
.bar {
  background: ${props => props.theme.firstColor} !important;
}
.progress {
  left: .5rem !important;
}
 .ui.progress {
  margin-bottom: 0px !important;
 }
`
export const LogoWrapper = styled.div`
background-size: contain;
background-repeat: no-repeat;
background-position: center;
width: 100%;
height: 70px;
margin-bottom: 1rem;
`;

export const SubmitHeader = styled.div`
font-size: 16px !important;
font-weight: bold;
`